import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Row, Col, Button } from "react-bootstrap";
import dataServices from "../../apiServices/data.services";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import { Can } from "../../context/AuthProvider";
import { handleValidationError } from "../../components/CommonFunctions";

const AddPayment = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    dataServices
      .getSubscriptions()
      .then((res) => {
        if (res.status === 200) {
          setPlans(res.data);
        }
      })
      .catch(() => {});
  }, []);

  const initialValues = {
    subscription_id: "",
    amount: "",
    payment_date: "",
    status: "completed",
    transaction_id: "",
    description: "",
    discount_amount: "",
  };

  const validationSchema = Yup.object().shape({
    subscription_id: Yup.string().required("Subscription is required"),
    amount: Yup.number().typeError("Amount must be numeric").required("Amount is required"),
    payment_date: Yup.string().required("Payment date is required"),
  });

  const handleSubmit = (values) => {
    handleManualPayment(values);
  };

  const handleManualPayment = (values) => {
    setLoading(true);
    dataServices
      .addPayment({ ...values, payment_type: "manual" })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          alert.success("Payment recorded successfully");
          navigate("/payments");
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 fw-bold text-black">Add Payment</h6>
      </div>
      <Can I="add" this="Payment">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ errors, touched, values }) => (
            <Form>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="subscription_id">Subscription <span className="text-danger">*</span></label>
                    <Field as="select" name="subscription_id" className={`form-control ${touched.subscription_id && errors.subscription_id ? "is-invalid" : ""}`}>
                      <option value="">Select subscription</option>
                      {plans.map((s) => (
                        <option key={s.id} value={s.id}>
                          #{s.id} - {s.plan?.name || "Plan"}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="subscription_id" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="amount">Amount <span className="text-danger">*</span></label>
                    <Field name="amount" type="text" className={`form-control ${touched.amount && errors.amount ? "is-invalid" : ""}`} />
                    <ErrorMessage name="amount" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="payment_date">Payment Date <span className="text-danger">*</span></label>
                    <Field name="payment_date" type="date" className={`form-control ${touched.payment_date && errors.payment_date ? "is-invalid" : ""}`} />
                    <ErrorMessage name="payment_date" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="status">Status</label>
                    <Field as="select" name="status" className="form-control">
                      <option value="completed">Completed</option>
                      <option value="pending">Pending</option>
                      <option value="failed">Failed</option>
                    </Field>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="transaction_id">Transaction ID</label>
                    <Field name="transaction_id" type="text" className="form-control" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="discount_amount">Discount Amount</label>
                    <Field name="discount_amount" type="text" className="form-control" />
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <Field name="description" as="textarea" rows={3} className="form-control" placeholder="Optional" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="footer mt-auto">
                  <Button type="submit" disabled={loading} className="btn btn-primary w-100">
                    {loading ? "Processing..." : "Save Payment"}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Can>
    </div>
  );
};

export default AddPayment;
